import { render, staticRenderFns } from "./PrintBangTongHopCongNo.vue?vue&type=template&id=c3dffb14"
import script from "./PrintBangTongHopCongNo.vue?vue&type=script&lang=js"
export * from "./PrintBangTongHopCongNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports